import { render, staticRenderFns } from "./trainingsHubTour.vue?vue&type=template&id=e6ddd92c&scoped=true"
import script from "./trainingsHubTour.vue?vue&type=script&lang=js"
export * from "./trainingsHubTour.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubTour.vue?vue&type=style&index=0&id=e6ddd92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ddd92c",
  null
  
)

export default component.exports